import type { Tone } from "@cx/ui";
import type {
  InboundDfeListItem,
  InboundImportStatus,
  InboundManifestEventView,
  InboundMatchSource,
  InboundSefazStatus,
} from "@cx/contracts";
import { MANIFEST_LABEL, type ManifestKind } from "@cx/domain";

export { MANIFEST_LABEL };

export const MANIFEST_TONE: Record<ManifestKind, Tone> = {
  ciencia: "info",
  confirmacao: "success",
  desconhecimento: "danger",
  nao_realizada: "warning",
};

export const SEFAZ_LABEL: Record<InboundSefazStatus, string> = {
  authorized: "Autorizada",
  denied: "Denegada",
  canceled: "Cancelada pelo emitente",
};
export const SEFAZ_TONE: Record<InboundSefazStatus, Tone> = {
  authorized: "success",
  denied: "danger",
  canceled: "danger",
};

export const IMPORT_LABEL: Record<InboundImportStatus, string> = {
  none: "Não lançada",
  imported: "Entrada lançada",
  reversed: "Entrada estornada",
};
export const IMPORT_TONE: Record<InboundImportStatus, Tone> = {
  none: "secondary",
  imported: "success",
  reversed: "warning",
};

export const MATCH_SOURCE_LABEL: Record<InboundMatchSource, string> = {
  supplier_code: "Código do fornecedor",
  gtin: "GTIN",
  ncm_description: "NCM e descrição",
  manual: "Manual",
  ai: "Sugestão da IA",
};

export const EVENT_STATUS_LABEL: Record<InboundManifestEventView["status"], string> = {
  pending: "Na fila",
  sending: "Enviando",
  registered: "Registrada",
  rejected: "Recusada",
};
export const EVENT_STATUS_TONE: Record<InboundManifestEventView["status"], Tone> = {
  pending: "info",
  sending: "info",
  registered: "success",
  rejected: "danger",
};

export const manifestInFlight = (e: Pick<InboundManifestEventView, "status">) =>
  e.status === "pending" || e.status === "sending";

export const inboundTitle = (d: Pick<InboundDfeListItem, "number" | "series">) =>
  d.number === null ? "NF-e (resumo)" : `NF-e ${d.number} / ${d.series ?? 1}`;
